import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Button from '../Button';
import { getParent, dispatchEvent } from '../utils/dom/element';
import { formConsumer } from './formContext';
export default (function (htmlType) {
  var _temp;

  return formConsumer(['disabled'], (_temp =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(FormButton, _PureComponent);

    var _super = _createSuper2(FormButton);

    function FormButton(props) {
      var _this;

      _classCallCheck(this, FormButton);

      _this = _super.call(this, props);
      _this.button = void 0;
      _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
      _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(FormButton, [{
      key: "bindElement",
      value: function bindElement(el) {
        this.button = el;
      }
    }, {
      key: "handleClick",
      value: function handleClick(e) {
        if (htmlType === 'button') {
          var form = getParent(this.button, 'form');
          dispatchEvent(form, 'submit', e.target);
        }

        if (this.props.onClick) this.props.onClick();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            children = _this$props.children,
            onClick = _this$props.onClick,
            other = _objectWithoutProperties(_this$props, ["children", "onClick"]);

        var type = this.props.type || (htmlType === 'reset' ? 'default' : 'primary');
        return (
          /*#__PURE__*/
          React.createElement(Button, Object.assign({}, other, {
            type: type,
            htmlType: htmlType,
            onRef: this.bindElement,
            onClick: this.handleClick
          }), children)
        );
      }
    }]);

    return FormButton;
  }(PureComponent), _temp));
});